import { render, staticRenderFns } from "./AsApiCalls.vue?vue&type=template&id=3a1f8cf2&scoped=true&"
import script from "./AsApiCalls.vue?vue&type=script&lang=js&"
export * from "./AsApiCalls.vue?vue&type=script&lang=js&"
import style0 from "./AsApiCalls.vue?vue&type=style&index=0&id=3a1f8cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1f8cf2",
  null
  
)

export default component.exports